// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/admin": [33,[6]],
		"/admin/appsettings": [34,[6]],
		"/admin/case-management": [35,[6]],
		"/admin/extensions": [36,[6]],
		"/admin/operations": [37,[6]],
		"/admin/roles": [38,[6]],
		"/admin/submissions": [39,[6]],
		"/admin/vehicle-reports": [40,[6]],
		"/portal": [41,[7]],
		"/portal/cases": [42,[7]],
		"/portal/submissions": [43,[7]],
		"/[lang]": [9],
		"/[lang]/admin": [22,[4]],
		"/[lang]/admin/appsettings": [23,[4]],
		"/[lang]/admin/case-management": [24,[4]],
		"/[lang]/admin/extensions": [25,[4]],
		"/[lang]/admin/operations": [26,[4]],
		"/[lang]/admin/roles": [27,[4]],
		"/[lang]/admin/submissions": [28,[4]],
		"/[lang]/admin/vehicle-reports": [29,[4]],
		"/[lang]/portal": [30,[5]],
		"/[lang]/portal/cases": [31,[5]],
		"/[lang]/portal/submissions": [32,[5]],
		"/[lang]/[area]": [10],
		"/[lang]/[area]/admin": [11,[2]],
		"/[lang]/[area]/admin/appsettings": [12,[2]],
		"/[lang]/[area]/admin/case-management": [13,[2]],
		"/[lang]/[area]/admin/extensions": [14,[2]],
		"/[lang]/[area]/admin/operations": [15,[2]],
		"/[lang]/[area]/admin/roles": [16,[2]],
		"/[lang]/[area]/admin/submissions": [17,[2]],
		"/[lang]/[area]/admin/vehicle-reports": [18,[2]],
		"/[lang]/[area]/portal": [19,[3]],
		"/[lang]/[area]/portal/cases": [20,[3]],
		"/[lang]/[area]/portal/submissions": [21,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);